import React, { useState } from "react";
import "./index.css";
import { useCan } from "../../utils/permissions";

const Index = ({ arg: { setActiveComponent, activeComponent } }) => {
  const handleClick = (navdata) => {
    setActiveComponent(navdata);
  };
  const can = useCan();
  const canReadTask = can("task", "read");
  const canReadNote = can("note", "read");

  return (
    <div className="d-flex mt-3">
      <div
        onClick={() => handleClick("info")}
        className={`sub2cont ${
          activeComponent === "info" ? "active" : "inactive"
        }`}
      >
        INFO
      </div>
      {canReadTask &&
      <div
        onClick={() => handleClick("tasks")}
        className={`sub2cont ${
          activeComponent === "tasks" ? "active" : "inactive"
        }`}
      >
        TASKS
      </div>
      }
      {canReadNote &&
      <div
        onClick={() => handleClick("notes")}
        className={`sub2cont ${
          activeComponent === "notes" ? "active" : "inactive"
        }`}
      >
        NOTES
      </div>
      }
      <div
        onClick={() => handleClick("closing-questioner")}
        className={`sub2cont ${
          activeComponent === "closing-questioner" ? "active" : "inactive"
        }`}
      >
        Questionnaire
      </div>
    </div>
  );
};

export default Index;
